// extracted by mini-css-extract-plugin
export default {"widget-container":"styles_widget-container__uKD6r"};